"use client"
/* */
const button = "flow--button";
const outline = "flow--button--outline";
const content = "flow--button--content";
const stateIcon = "flow--button--state-icon";
const icon = "flow--button--icon";
const text = "flow--button--text";
const counterBadge = "flow--button--counter-badge";
const isPending = "flow--button--is-pending";
const isFailed = "flow--button--is-failed";
const isSucceeded = "flow--button--is-succeeded";
const plain = "flow--button--plain";
const image = "flow--button--image";
const primary = "flow--button--primary";
const solid = "flow--button--solid";
const ariaDisabled = "flow--button--aria-disabled";
const accent = "flow--button--accent";
const danger = "flow--button--danger";
const secondary = "flow--button--secondary";
const dark = "flow--button--dark";
const light = "flow--button--light";
const soft = "flow--button--soft";
const avatar = "flow--button--avatar";
const styles = {
	button: button,
	outline: outline,
	content: content,
	stateIcon: stateIcon,
	icon: icon,
	text: text,
	counterBadge: counterBadge,
	isPending: isPending,
	isFailed: isFailed,
	isSucceeded: isSucceeded,
	plain: plain,
	"size-s": "flow--button--size-s",
	image: image,
	primary: primary,
	solid: solid,
	ariaDisabled: ariaDisabled,
	accent: accent,
	danger: danger,
	secondary: secondary,
	dark: dark,
	light: light,
	soft: soft,
	avatar: avatar
};

export { accent, ariaDisabled, avatar, button, content, counterBadge, danger, dark, styles as default, icon, image, isFailed, isPending, isSucceeded, light, outline, plain, primary, secondary, soft, solid, stateIcon, text };
//# sourceMappingURL=Button.module.scss.mjs.map
